<div ngClass="{{customClasess}}">
    <ngx-slider (click)="$event.stopPropagation()" [options]="options" [(value)]="value" [highValue]="highValue" (userChange)="onInputChange($event)" (valueChange)="onValueChange($event)"></ngx-slider>
</div>